import React from 'react'
import { BANKING_BOTTOM_CONTENT, CERTIFICATION_COURSE_PAGE_2, CERTIFICATION_DETAILS_PAGE_2, CERTIFICATION_HERO_PAGE_2 } from '../../../utils/constants'
import CourseCard from '../../../reusable/Course-card'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { CERTIFICATION_ACCORDIAN_2 } from '../../../utils/courseConifg'

const CertificationPage_2 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CERTIFICATION_HERO_PAGE_2}/>
     <CoursesAside {...CERTIFICATION_COURSE_PAGE_2}/>
     <CourseCard {...CERTIFICATION_DETAILS_PAGE_2}/>
     <Accordian {...CERTIFICATION_ACCORDIAN_2}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CertificationPage_2